import React from 'react';
import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../Styles';

export const BarclaysPingPongFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.barclaysPingPong.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Ltd.',
    },
    { description: 'supplierValidation.afterRegister.checkingAccount', value: '84799366' },
    { description: 'supplierValidation.afterRegister.swift', value: 'BARCGB22' },
    { description: 'supplierValidation.afterRegister.iban', value: 'GB35BARC20000084799366' },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Barclays Bank PLC
        <br />
        1 Churchill Place,
        <br />
        London E14 5HP
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.transferMustBe',
      'supplierValidation.afterRegister.bofaPingPong.pleaseNote',
    ],
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: [
    'supplierValidation.afterRegister.barclaysPingPong.step1',
    'supplierValidation.afterRegister.barclaysPingPong.step2',
  ],
};
